import { EsResponseModel } from '../../../shared/EsResponseModel';

export interface FavoriteServiceDto {
  ProcedureId: string;
  IdString: string;
  Code: null;
  NameAr: string;
  NameEn: string;
  Url: null;
}

export class FavoriteService {
  procedureId: string;
  id: string;
  code: null;
  url: null;
}

export class FavoriteServicesResponse extends EsResponseModel<
  FavoriteServiceDto[]
> {}

export class FavoriteServicesToggleResponse extends EsResponseModel<boolean> {}

export class FavoriteServiceToggleRequest {
  procedureId: string;
  isFavorite: boolean;
}
